//Action creator with callback function
export function addNexusRegistrationDetail(registrationDetails) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_NEXUS_REGISTRATION_DETAIL',
                payload: registrationDetails
            });
            resolve(true)
        });
    }
};

export const resetNexusRegistrationDetail = () => ({
    type: 'RESET_NEXUS_REGISTRATION_DETAIL'
});